<template>
    <v-container class="booking-list-container" fluid>
        <v-row>
            <v-col>
                <v-select :label="$t('booking.facility')"
                          :items="facilityTypeOptions"
                          v-model="selectedFacilityType"></v-select>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-data-table :items="filteredBookings"
                              :headers="bookingHeaders"
                              :loading="bookings == null">
                    <template v-slot:item.create_at="{value}">
                        {{DateTime.fromISO(value).toFormat('yyyy-MM-dd HH:mm:ss')}}
                    </template>
                    <template v-slot:item.facility="{item}">
                        {{facilityLabel(item)}}
                    </template>
                    <template v-slot:item.status="{item}">
                        {{statusLabel(item)}}
                    </template>
                    <template v-slot:item.actions="{item}">
                        <v-btn icon color="primary"
                               :to="{name: 'booking-detail', params: {bookingRecordId: item.id}}">
                            <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                        <v-btn icon color="primary"
                               :to="{name: 'booking-preview', params: {bookingRecordId: item.booking_record.id}}"
                               v-if="item.status === 0">
                            <v-icon>mdi-cash-register</v-icon>
                        </v-btn>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <b-row v-if="filteredBookings.length === 0" class="mt-3">
            <b-col class="text-center booking-list-empty">
                {{$t('booking.no_booking')}}
            </b-col>
        </b-row>
    </v-container>
</template>

<script>
    import {library} from '@fortawesome/fontawesome-svg-core'
    import {faCashRegister, faSearch} from '@fortawesome/free-solid-svg-icons'
    import {DateTime} from 'luxon'
    import {BOOKING_STATUS_LABEL} from "../../../constants";
    import _ from 'lodash'

    library.add(faSearch, faCashRegister);

    export default {
        name: 'BookingList',
        data() {
            let v = this;
            return {
                facilityTypes: [],
                selectedFacilityType: null,

                bookings: null,
                bookingHeaders: [
                    {text: this.$t('booking.create_at'), value: 'create_at'},
                    {text: this.$t('booking.facility'), value: 'facility'},
                    {text: this.$t('booking.status'), value: 'status'},
                    {text: '', value: 'actions'},
                ],
                currentPage: 1,
                perPage: 20,

                DateTime,
            };
        },
        mounted() {
            this.getBookings();
            this.getFacilityTypes();
        },
        computed: {
            facilityTypeOptions() {
                return _.concat([{value: null, text: this.$t('all')}], _.filter(this.facilityTypes, 'open_for_booking').map(function (t) {
                    return {value: t, text: t.name};
                }));
            },
            filteredBookings() {
                if (this.bookings == null) {
                    return [];
                }

                let filteredBookings = this.bookings;
                let v = this;

                if (this.selectedFacilityType) {
                    filteredBookings = _.filter(filteredBookings, function (r) {
                        return r.item.type.id === v.selectedFacilityType.id;
                    })
                }

                return filteredBookings;
            },
        },
        methods: {
            getFacilityTypes() {
                this.$callAPI('aafb/facility_types/', {}, function (response) {
                    this.facilityTypes = response.body.item_types;
                });
            },
            getBookings() {
                this.$callAPI('aafb/booking/', {}, function (response) {
                    this.bookings = response.body.bookings;
                });
            },
            bookingCreateAtLabel(record) {
                return DateTime.fromISO(record.create_at).setLocale('en').toFormat('yyyy-MM-dd HH:mm:ss');
            },
            facilityLabel(record) {
                return DateTime.fromISO(record.start_time).setLocale('en').toFormat('yyyy-MM-dd HH:mm') + ' - ' + DateTime.fromISO(record.end_time).toFormat('HH:mm') + "  " + record.item.name;
            },
            statusLabel(record) {
                return this.$t(BOOKING_STATUS_LABEL[record.status]);
            },
        },
    }
</script>

<style lang="less">
    .booking-list-container {
        text-align: left;
        padding: 24px;

        .booking-list-title-label {
            text-align: left;
            font-size: 2.5em;
        }

        .fa-search, .fa-cash-register {
            border-radius: 10px;
            font-size: 2em;
            padding: 5px;
            cursor: pointer;

            &:hover {
                background-color: black;
                color: white;
            }
        }

        .booking-list-empty {
            color: #444;
            font-size: 2rem;
        }
    }
</style>
